import React from 'react';
import * as styles from './PostRowToolbar.module.scss';
import Button from '../../../components/Button';
import type { DocumentType } from '../../../graphql/generated/gql';
import { gql } from '../../../graphql/generated/gql';
import newTabIcon from '../../../icons/non-prefilled/16x16/newTab.svg';
import popoutIcon from '../../../icons/non-prefilled/extension/popout.svg';
import postPath from '../../../utils/url/postPath';
import sendMessageToSlabFrame from '../sendMessageToSlabFrame';

const POST_FRAGMENT = gql(`
  fragment PostRowToolbar_post on Post {
    id
    ...postPath_post
  }
`);

interface PostRowToolbarProps {
  post: DocumentType<typeof POST_FRAGMENT>;
  postRowRef: React.RefObject<HTMLDivElement>;
}

const PostRowToolbar = ({ post, postRowRef }: PostRowToolbarProps) => {
  return (
    <div className={styles.container}>
      <Button
        className={styles.button}
        icon={popoutIcon}
        onClick={() => {
          sendMessageToSlabFrame({
            'slab.type': 'hovercard.persist',
            'slab.data': {
              id: post.id,
              preferredTop:
                postRowRef.current?.getBoundingClientRect().top ?? 0,
            },
          });
        }}
        aria-label="Pop out post"
      />
      <Button
        className={styles.button}
        icon={newTabIcon}
        to={postPath(post)}
        onClick={(e) => {
          e.stopPropagation();
        }}
        newTab
        aria-label="Open in Slab"
      />
    </div>
  );
};

export default PostRowToolbar;
